'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_UnauthenticatedAppUpdate$$anon$17(evaluator$27) {
  this.Lapp_api_UnauthenticatedAppUpdate$$anon$17__f_evaluator$3 = null;
  this.Lapp_api_UnauthenticatedAppUpdate$$anon$17__f_evaluator$3 = evaluator$27;
}
export { $c_Lapp_api_UnauthenticatedAppUpdate$$anon$17 as $c_Lapp_api_UnauthenticatedAppUpdate$$anon$17 };
$c_Lapp_api_UnauthenticatedAppUpdate$$anon$17.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_UnauthenticatedAppUpdate$$anon$17.prototype.constructor = $c_Lapp_api_UnauthenticatedAppUpdate$$anon$17;
/** @constructor */
function $h_Lapp_api_UnauthenticatedAppUpdate$$anon$17() {
}
export { $h_Lapp_api_UnauthenticatedAppUpdate$$anon$17 as $h_Lapp_api_UnauthenticatedAppUpdate$$anon$17 };
$h_Lapp_api_UnauthenticatedAppUpdate$$anon$17.prototype = $c_Lapp_api_UnauthenticatedAppUpdate$$anon$17.prototype;
$c_Lapp_api_UnauthenticatedAppUpdate$$anon$17.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_UnauthenticatedAppUpdate$$anon$17.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_UnauthenticatedAppUpdate$$anon$17__f_evaluator$3.apply__O();
  return (((typeof v) === "boolean") ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_UnauthenticatedAppUpdate$$anon$17.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_UnauthenticatedAppUpdate$$anon$17 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_UnauthenticatedAppUpdate$$anon$17, "app.api.UnauthenticatedAppUpdate$$anon$17", ({
  Lapp_api_UnauthenticatedAppUpdate$$anon$17: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_UnauthenticatedAppUpdate$$anon$17 as $d_Lapp_api_UnauthenticatedAppUpdate$$anon$17 };
//# sourceMappingURL=app.api.-Unauthenticated-App-Update$$anon$17.js.map
